import { render, staticRenderFns } from "./TqMoreInfo.vue?vue&type=template&id=dbd6e050&scoped=true&"
import script from "./TqMoreInfo.vue?vue&type=script&lang=js&"
export * from "./TqMoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./TqMoreInfo.vue?vue&type=style&index=0&id=dbd6e050&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd6e050",
  null
  
)

export default component.exports